module.exports = __webpack_public_path__ + "img/nbf.a1cc4ab5.png";